module.exports = __webpack_public_path__ + "img/董世勇.9931ef93.jpg";